import { Alert } from 'react-bootstrap'
import { InfoIcon } from '../../../common/icons'

/** Info component used in calendar event settings */
export function InfoComponent({ header, body }) {
  return (
    <Alert className="mb-4" style={{ padding: 0, border: '1px solid #0A60C2', borderRadius: '8px', letterSpacing: '0.15px' }}>
      <div style={{ display: 'flex', gap: 0, borderRadius: '8px', overflow: 'hidden' }}>
        <div
          style={{
            backgroundColor: '#FCFCFD',
            padding: '12px 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '60px',
            borderRadius: '8px 0 0 8px'
          }}
        >
          <InfoIcon fill="#0A60C2"/>
        </div>
        <div
          style={{
            backgroundColor: '#FCFCFD',
            padding: '12px 16px',
            flex: 1,
            borderRadius: '0 8px 8px 0',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <h6
            style={{
              margin: '0 0 4px 0',
              fontSize: '13px',
              fontWeight: '600',
              color: '#003066'
            }}
          >
            {header}
          </h6>
          <p
            style={{
              margin: 0,
              fontSize: '13px',
              color: '#003066',
              lineHeight: '1.4'
            }}
          >
            {body}
          </p>
        </div>
      </div>
    </Alert>
  )
}
